import React from "react";
import Icon from "./Icon";
export default function Arrow(props) {
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("path", {
    d: "M11 4.58334V17.4167"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4166 11L11 17.4167L4.58331 11"
  }));
}
Arrow.displayname = "Arrow";
//# sourceMappingURL=Arrow.js.map